import React from 'react';
import { Link } from 'react-router-dom';
import { systemCode, urls } from '..';
import LiveSortButton from '../live/LiveSortButton';
import MenuToggle from './settings-menu/MenuToggle';
import SearchButton from './search/SearchButton';
import useIsLiveSection from './useIsLiveSection';
import ScannerButton from './ticket-scanner/ScannerButton';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getConfiguration } from '../data/utils/configuration';
import HiddenTopbar from './hidden-topbar/HiddenTopbar';

function DefaultMenu(props) {
    const conf = getConfiguration();
    const isLiveSection = useIsLiveSection();
    const url = isLiveSection ? removeMultipleSlashes(`${urls.base}/${urls.live.base}`) : removeMultipleSlashes(`${urls.base}/${urls.prematch.base}`);

    if (conf.iwh) {
        return <div className={`topMenu__searchButton__wrapper ${props.title}`}> <SearchButton {...props} /></div>
    }

    return (
        <div className="xs_topMenu h-[30px] px-2 flex items-center justify-between h-header-height bg-cc1 topMenu--isSearch">
            <Link to={url} className="justify-self-start font-medium text-md text-cs1">{props.title}</Link>
            <div className="grid grid-flow-col gap-4">
                {props.showSortButtonLive &&
                    <div className="relative h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md">
                        <LiveSortButton />
                    </div>
                }
                <div className="h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md">
                    <SearchButton {...props} />
                </div>
                {conf.mst !== 'NONE' &&
                    <div className="h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md">
                        <ScannerButton />
                    </div>
                }
                <MenuToggle />
            </div>
        </div>
    );
}

export default function TopMenu(props) {
    const conf = getConfiguration();

    if (conf.hmtb) {
        return <HiddenTopbar />;
    }

    return <DefaultMenu {...props} />;
}
